import "./about.css";
import profileImage from "../assets/img/profileImage.jpeg";

import Fade from "react-reveal/Fade";

const About = () => {
  return (
    <Fade bottom>
      <div id="about" className="about-container ">
        <div className="row">
          <div className="col-md-6">
            <div className="about-title">
              <span className="color-primary font-family-class">01. </span>{" "}
              About Me
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <p className="about-paragraph">
              {" "}
              Hello! I am Zabihullah, a software engineer and Full Stack
              Developer with a bachelor in Computer Applications from Bangalore
              City University, India, and Currently pursuing my Masters in
              Computer Applications field in Bangalore University, India.
            </p>
            <p className="about-paragraph">
              I have started engaging in tech challenges and exploring the world
              of programming and network back in the days when I was in school,
              fast forward to today, I have created many applications for
              myself, for fun and clients, and have been working as a freelancer
              full stack developer since 3 years.
            </p>
            <p className="about-paragraph">
              here are a few technologies I'm working with most of the time:
            </p>
            <div className="row flex-nowrap">
              <div className="w-auto">
                <ul className="about-list font-family-class">
                  <li>Javascript (ES6+)</li>
                  <li>React</li>
                  <li>Express.js</li>
                  <li>Typescript</li>
                </ul>
              </div>
              <div className="w-auto">
                <ul className="about-list font-family-class">
                  <li>Node.js</li>
                  <li>MongoDB</li>
                  <li>Mongoose</li>
                  <li>Wordpress</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 about-image_container">
            <div className="about-image_wrapper">
              <img className="about-image" src={profileImage} alt="profile" />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default About;
